module.exports = __webpack_public_path__ + "img/ibisz80.2f7f8e70.jpg";